/* eslint-disable prettier/prettier */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MaterialGrid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { Box, Button, TextField, Dialog, IconButton, FormHelperText } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import Alert from '@material-ui/lab/Alert';
import AsyncSelect from 'react-select/async';
import axios from 'axios';
import moment from 'moment';
import 'moment/locale/pt-br';
import PrimaryButton from 'common/components/buttons/primaryButton';
import SecondaryButton from 'common/components/buttons/secondaryButton';
import { EditorConvertToHTMLActivity } from 'common/components/fields/EditorConvertToHTMLActivity';
import { InputSwitchLarge } from 'common/components/fields/InputSwitchLarge';
import { InputLabelOutlined } from 'common/components/fields/InputLabelOutlined';
import { SelectLabel } from 'common/components/fields/SelectLabel';
import { SelectMultiple } from 'common/components/fields/SelectMultiple';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Field, reduxForm, getFormValues, change } from 'redux-form';
import { LimitByAudienceField } from '../../sections/LimitByAudienceField';
import { FORM_RULES } from 'helpers/validations';
import { publishToStations } from '../vendasOnlineParceiroActions';
import {
  getContactsByStationIdLimited,
  getUsersByIds,
  getContactsByMultipleStationsLimited,
} from '../../../contacts/contactsActions';
import { getList as getPlansList } from '../../../plans/plansActions';
import states from 'helpers/states.json';
import { BASE_API, USER_TOKEN } from 'config/consts';
import {
  AudienceSection,
  AUDIENCE_OPTIONS,
  audienceCheckbox,
  initAudienceFields,
  isAudienceFeatureApplicable,
  isStationGuestFeatureEnabled,
  buildAudienceTypes,
  hasAnyAudienceSelected,
} from '../../sections/audienceSection';

moment.locale('pt-br');

class Configuracoes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      startDate: props.formValues?.start ? new Date(props.formValues.start) : null,
      endDate: props.formValues?.end ? new Date(props.formValues.end) : null,
      participationStart: props.formValues?.participationStart
        ? new Date(props.formValues.participationStart)
        : null,
      participationEnd: props.formValues?.participationEnd
        ? new Date(props.formValues.participationEnd)
        : null,
      isSubmitting: false,
      showConfirmCreate: false,
      isAsyncInputDirty: false,
    };
  }

  componentDidMount() {
    // Carregar lista de planos
    const stationId = this.props.auth?.user?.establishments?.[0]?.stations?.[0]?.id;
    if (stationId) {
      this.props.getPlansList(stationId);
    }

    initAudienceFields({
      auth: this.props.auth,
      formValues: this.props.formValues,
      changeField: (formName, field, value) => this.props.changeFieldAny(formName, field, value),
      form: 'vendasOnlineParceiroForm',
    });
  }

  componentDidUpdate(prevProps) {
    const { formValues } = this.props;
    const prevFormValues = prevProps.formValues;

    // Atualizar datas quando o ID da atividade mudar (nova atividade carregada)
    if (formValues?.id && formValues.id !== prevFormValues?.id) {
      this.setState({
        startDate: formValues.start ? new Date(formValues.start) : null,
        endDate: formValues.end ? new Date(formValues.end) : null,
        participationStart: formValues.participationStart
          ? new Date(formValues.participationStart)
          : null,
        participationEnd: formValues.participationEnd
          ? new Date(formValues.participationEnd)
          : null,
      });
    }
  }

  // Método para buscar usuários de forma assíncrona
  lazySelect = ({ input, meta }) => {
    const { formValues, auth } = this.props;

    // Pegar stations selecionadas ou usar a station principal
    const selectedStations = Array.isArray(formValues?.stations_field)
      ? formValues.stations_field
      : [];
    const mainStationId = auth?.user?.establishments?.[0]?.stations?.[0]?.id;
    const stationIds =
      selectedStations.length > 0
        ? selectedStations.map((s) => s.value || s.id || s)
        : [mainStationId];

    const hasMultipleStations = stationIds.length > 1;

    const loadOptions = async (inputValue) => {
      if (!inputValue || inputValue.length < 3) return [];

      try {
        const response = await getContactsByMultipleStationsLimited(stationIds, inputValue);
        return response.map((user) => {
          const stationName = user.station?.name || '';
          const label =
            hasMultipleStations && stationName
              ? `${user.name} - ${user.email} (${stationName})`
              : `${user.name} - ${user.email}`;

          return {
            value: user.id,
            label,
            stationName,
          };
        });
      } catch (error) {
        console.error('Erro ao buscar usuários:', error);
        return [];
      }
    };

    return (
      <Box>
        <Typography variant="body2" style={{ marginBottom: 8 }}>
          Selecione os usuários
        </Typography>
        <AsyncSelect
          {...input}
          isMulti
          cacheOptions
          defaultOptions
          loadOptions={loadOptions}
          placeholder="Digite para buscar usuários..."
          noOptionsMessage={() => 'Digite pelo menos 3 caracteres'}
          onChange={(value) => {
            input.onChange(value);
            this.setState({ isAsyncInputDirty: true });
          }}
          onBlur={() => input.onBlur(input.value)}
          menuPortalTarget={document.body}
          menuPosition="fixed"
          styles={{
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            menu: (base) => ({ ...base, zIndex: 9999 }),
          }}
        />
        {meta.touched && meta.error && (
          <Typography variant="caption" color="error">
            {meta.error}
          </Typography>
        )}
      </Box>
    );
  };

  validateForm = () => {
    const { formValues, auth } = this.props;
    const errors = [];

    if (!formValues?.body_name) {
      errors.push('Nome da atividade é obrigatório');
    }

    if (!this.state.startDate) {
      errors.push('Data de início é obrigatória');
    }

    if (this.state.endDate && this.state.startDate && this.state.endDate < this.state.startDate) {
      errors.push('Data de término deve ser posterior à data de início');
    }

    if (isStationGuestFeatureEnabled(auth) && !hasAnyAudienceSelected(formValues)) {
      errors.push('Selecione pelo menos um público (Filiados, Amigos ou Dependentes)');
    }

    return errors;
  };

  // Abre o modal de confirmação
  handleOpenConfirmCreate = (e) => {
    e.preventDefault();
    const errors = this.validateForm();
    if (errors.length > 0) {
      alert(errors.join('\n'));
      return;
    }
    this.setState({ showConfirmCreate: true });
  };

  handleCloseConfirmCreate = () => {
    this.setState({ showConfirmCreate: false });
  };

  handleConfirmCreate = async () => {
    const { formValues, auth } = this.props;
    this.setState({ isSubmitting: true, showConfirmCreate: false });

    try {
      const audienceTypes = buildAudienceTypes(auth, formValues);
      const publishData = {
        ...formValues,
        start: this.state.startDate?.toISOString(),
        end: this.state.endDate?.toISOString(),
        participationStart: this.state.participationStart?.toISOString(),
        participationEnd: this.state.participationEnd?.toISOString(),
        active: 1,
        is_draft: 0,
        station_id: this.props.auth.user.establishments[0].stations[0].id,
        ...(audienceTypes ? { audience_types: audienceTypes } : {}),
      };

      await this.props.publishToStations(publishData, this.props.closeModal);
    } catch (error) {
      console.error('Erro ao publicar:', error);
    } finally {
      this.setState({ isSubmitting: false });
    }
  };

  onSubmit = (values) => {
    // console.log('Form values:', values);
  };

  render() {
    const { handleSubmit, formValues } = this.props;
    const { startDate, endDate, participationStart, participationEnd, isSubmitting } = this.state;

    // Resumo da atividade
    const partnersCount = formValues?.partners_split?.length || 0;
    const productsCount = formValues?.products?.length || 0;
    const stationsCount = formValues?.stations_field?.length || 0;

    // Formatar datas para input datetime-local
    const formatDateForInput = (date) => {
      if (!date) return '';
      return moment(date).format('YYYY-MM-DDTHH:mm');
    };

    return (
      <form onSubmit={handleSubmit(this.onSubmit)}>
        <div style={{ overflowY: 'scroll', height: 'calc(100vh - 355px)', padding: '0 10px' }}>
          {/* Resumo */}
          <Box
            style={{ marginBottom: 24, padding: 16, backgroundColor: '#f5f5f5', borderRadius: 4 }}>
            <Typography variant="subtitle2" gutterBottom>
              Resumo da Atividade
            </Typography>
            <Typography variant="body2">
              <strong>Nome:</strong> {formValues?.body_name || 'Não definido'}
            </Typography>
            <Typography variant="body2">
              <strong>Parceiros:</strong> {partnersCount} parceiro(s) configurado(s)
            </Typography>
            <Typography variant="body2">
              <strong>Produtos:</strong> {productsCount} produto(s) cadastrado(s)
            </Typography>
            <Typography variant="body2">
              <strong>Stations:</strong> {stationsCount} station(s) selecionada(s)
            </Typography>
            <Typography variant="body2">
              <strong>Tipo de Venda:</strong>{' '}
              {formValues?.recurrence_type === 'single'
                ? 'Venda única'
                : formValues?.recurrence_type || 'Não definido'}
            </Typography>
            {formValues?.allow_installments && (
              <Typography variant="body2">
                <strong>Parcelamento:</strong> Até {formValues?.installments_count || 12}x
              </Typography>
            )}

            {/* Valores dos Produtos */}
            {formValues?.products?.length > 0 && (
              <Box style={{ marginTop: 12, paddingTop: 12, borderTop: '1px solid #ddd' }}>
                <Typography variant="subtitle2" gutterBottom>
                  Valores dos Produtos:
                </Typography>
                {formValues.products.map((product, index) => (
                  <Typography key={index} variant="body2">
                    • {product.name || `Produto ${index + 1}`}: R${' '}
                    {(parseFloat(product.price) || 0).toFixed(2).replace('.', ',')}
                  </Typography>
                ))}
                <Typography variant="body2" style={{ marginTop: 8, fontWeight: 'bold' }}>
                  Total: R${' '}
                  {formValues.products
                    .reduce((sum, p) => sum + (parseFloat(p.price) || 0), 0)
                    .toFixed(2)
                    .replace('.', ',')}
                </Typography>
              </Box>
            )}

            {/* Taxa de Administração */}
            {this.props.auth?.user?.establishments?.[0]?.stations?.[0]?.administration_tax && (
              <Box style={{ marginTop: 12, paddingTop: 12, borderTop: '1px solid #ddd' }}>
                <Typography variant="subtitle2" gutterBottom>
                  Taxa de Administração:
                </Typography>
                <Typography variant="body2">
                  <strong>Taxa:</strong>{' '}
                  {this.props.auth.user.establishments[0].stations[0].administration_tax}%
                </Typography>
                <Typography variant="caption" color="textSecondary">
                  Além da taxa citada acima, tem o acréscimo de R$ 1,50 de antifraude por transação.
                </Typography>
              </Box>
            )}

            {/* Divisão de Valores */}
            {formValues?.partners_split?.length > 0 && (
              <Box style={{ marginTop: 12, paddingTop: 12, borderTop: '1px solid #ddd' }}>
                <Typography variant="subtitle2" gutterBottom>
                  Divisão de Valores:
                </Typography>
                {formValues.partners_split.map((partner, index) => (
                  <Typography key={index} variant="body2">
                    • {partner.name || `Parceiro ${index + 1}`}: {partner.percentage}%
                  </Typography>
                ))}
                <Typography variant="body2">
                  • Estação:{' '}
                  {(
                    100 -
                    formValues.partners_split.reduce(
                      (sum, p) => sum + (parseFloat(p.percentage) || 0),
                      0
                    )
                  ).toFixed(2)}
                  %
                </Typography>
              </Box>
            )}
          </Box>

          {/* Datas */}
          <Typography variant="subtitle2" gutterBottom>
            Período da Atividade
          </Typography>

          <MaterialGrid container spacing={2} style={{ marginBottom: 24 }}>
            <MaterialGrid item xs={12} sm={6}>
              <TextField
                label="Data de Início"
                type="datetime-local"
                fullWidth
                variant="outlined"
                InputLabelProps={{ shrink: true }}
                value={formatDateForInput(startDate)}
                onChange={(e) => {
                  const newDate = e.target.value ? new Date(e.target.value) : null;
                  this.setState({ startDate: newDate });
                  this.props.change('start', newDate ? newDate.toISOString() : null);
                }}
              />
            </MaterialGrid>
            <MaterialGrid item xs={12} sm={6}>
              <TextField
                label="Data de Término"
                type="datetime-local"
                fullWidth
                variant="outlined"
                InputLabelProps={{ shrink: true }}
                value={formatDateForInput(endDate)}
                onChange={(e) => {
                  const newDate = e.target.value ? new Date(e.target.value) : null;
                  this.setState({ endDate: newDate });
                  this.props.change('end', newDate ? newDate.toISOString() : null);
                }}
              />
            </MaterialGrid>
          </MaterialGrid>

          <Typography variant="subtitle2" gutterBottom>
            Período de Participação (opcional)
          </Typography>

          <MaterialGrid container spacing={2} style={{ marginBottom: 24 }}>
            <MaterialGrid item xs={12} sm={6}>
              <TextField
                label="Início das Participações"
                type="datetime-local"
                fullWidth
                variant="outlined"
                InputLabelProps={{ shrink: true }}
                value={formatDateForInput(participationStart)}
                onChange={(e) => {
                  const newDate = e.target.value ? new Date(e.target.value) : null;
                  this.setState({ participationStart: newDate });
                  this.props.change('participationStart', newDate ? newDate.toISOString() : null);
                }}
              />
            </MaterialGrid>
            <MaterialGrid item xs={12} sm={6}>
              <TextField
                label="Fim das Participações"
                type="datetime-local"
                fullWidth
                variant="outlined"
                InputLabelProps={{ shrink: true }}
                value={formatDateForInput(participationEnd)}
                onChange={(e) => {
                  const newDate = e.target.value ? new Date(e.target.value) : null;
                  this.setState({ participationEnd: newDate });
                  this.props.change('participationEnd', newDate ? newDate.toISOString() : null);
                }}
              />
            </MaterialGrid>
          </MaterialGrid>

          {/* Regulamento */}
          <Typography variant="subtitle2" gutterBottom>
            Regulamento
          </Typography>
          <Box style={{ marginBottom: 24 }}>
            <Field
              component={EditorConvertToHTMLActivity}
              label="Regulamento"
              name="rules"
              placeholder="Insira o regulamento da atividade"
            />
          </Box>

          {/* Termos */}
          <Typography variant="subtitle2" gutterBottom>
            Termos e Condições
          </Typography>
          <Box style={{ marginBottom: 24 }}>
            <Field
              component={EditorConvertToHTMLActivity}
              label="Termos"
              name="terms"
              placeholder="Insira os termos e condições"
            />
          </Box>

          {/* Ordem e Carrossel */}
          <MaterialGrid item xs={12}>
            <Field component={InputSwitchLarge} label="Ordem" name="hasPriority" margin="normal" />
          </MaterialGrid>
          {formValues?.hasPriority && (
            <MaterialGrid item xs={12}>
              <Field
                component={InputLabelOutlined}
                label="1-1000"
                helperText="Determina a posição desta atividade na estação."
                name="priority"
                type="number"
                margin="normal"
              />
            </MaterialGrid>
          )}

          <MaterialGrid item xs={12}>
            <Field
              component={InputSwitchLarge}
              label="Ordenar no carrossel"
              name="hasPriorityInCarousel"
              margin="normal"
            />
          </MaterialGrid>
          {formValues?.hasPriorityInCarousel && (
            <MaterialGrid item xs={12}>
              <Field
                component={InputLabelOutlined}
                label="1-1000"
                helperText="Posição no carrossel em destaque."
                name="priorityCarousel"
                type="number"
                margin="normal"
              />
            </MaterialGrid>
          )}

          {/* Limites de Participação */}
          <Typography variant="subtitle2" style={{ marginTop: 16, marginBottom: 8 }}>
            Limites de Participação
          </Typography>
          <MaterialGrid container spacing={2}>
            <MaterialGrid item xs={12} md={6}>
              <Field
                component={InputLabelOutlined}
                label="Limite total de participações"
                name="limit"
                type="number"
                helperText="0 = ilimitado"
                margin="normal"
              />
            </MaterialGrid>
            <MaterialGrid item xs={12} md={6}>
              <Field
                component={InputLabelOutlined}
                label="Limite por usuário"
                name="limitPerUser"
                type="number"
                helperText="Deixe vazio para ilimitado"
                margin="normal"
              />
            </MaterialGrid>
          </MaterialGrid>
          <LimitByAudienceField
            auth={this.props.auth}
            formValues={this.props.formValues}
            typeId={22}
            isDisabled={false}
          />

          {/* Segmentação de Público */}
          <MaterialGrid item xs={12} style={{ marginTop: 16 }}>
            <Field
              component={InputSwitchLarge}
              label="Limitar atividade por público alvo"
              name="has_target"
              margin="normal"
            />
          </MaterialGrid>

          {formValues?.has_target &&
            (() => {
              const inlineAudience =
                isStationGuestFeatureEnabled(this.props.auth) &&
                isAudienceFeatureApplicable(formValues) &&
                formValues?.segmentation_type === 'public';
              const leftCol = inlineAudience ? 6 : 12;
              return (
                <MaterialGrid container spacing={2} style={{ marginTop: 16 }}>
                  <MaterialGrid item xs={12} md={leftCol}>
                    <Typography variant="subtitle2" style={{ marginBottom: 8 }}>
                      Definir público alvo
                    </Typography>
                    <MaterialGrid container spacing={2}>
                      <MaterialGrid item xs={12} md={inlineAudience ? 12 : 6}>
                        <Field
                          component={SelectLabel}
                          label="Tipo de segmentação"
                          name="segmentation_type"
                          options={[
                            { value: 'public', label: 'Por público' },
                            { value: 'users', label: 'Para usuários específicos' },
                          ]}
                          validate={[FORM_RULES.required]}
                          margin="normal"
                        />
                      </MaterialGrid>
                    </MaterialGrid>

                    {formValues?.segmentation_type === 'users' ? (
                      <MaterialGrid container spacing={2} style={{ marginTop: 8 }}>
                        <MaterialGrid item xs={12}>
                          <Field
                            name="segment_users"
                            component={this.lazySelect}
                            validate={[FORM_RULES.required]}
                            margin="normal"
                          />
                        </MaterialGrid>
                      </MaterialGrid>
                    ) : formValues?.segmentation_type === 'public' ? (
                      <>
                        <MaterialGrid container spacing={2} style={{ marginTop: 8 }}>
                          <MaterialGrid item xs={6} md={inlineAudience ? 6 : 3}>
                            <Field
                              component={InputLabelOutlined}
                              label="De (anos)"
                              name="from"
                              type="number"
                              validate={[FORM_RULES.required]}
                              margin="normal"
                            />
                          </MaterialGrid>
                          <MaterialGrid item xs={6} md={inlineAudience ? 6 : 3}>
                            <Field
                              component={InputLabelOutlined}
                              label="Até (anos)"
                              name="to"
                              type="number"
                              validate={[FORM_RULES.required]}
                              margin="normal"
                            />
                          </MaterialGrid>
                        </MaterialGrid>

                        <Typography variant="subtitle2" style={{ marginTop: 16, marginBottom: 8 }}>
                          Local de divulgação
                        </Typography>
                        <MaterialGrid container spacing={2}>
                          <MaterialGrid item xs={12} md={inlineAudience ? 12 : 6}>
                            <Field
                              component={SelectMultiple}
                              label="Estados que poderão participar"
                              name="states"
                              options={[
                                { value: 'all', label: 'Todos os estados' },
                                ...states.map((s) => ({ value: s.sigla, label: s.nome })),
                              ]}
                              multiple
                              validate={[FORM_RULES.required]}
                              margin="normal"
                            />
                            <Typography variant="caption" color="textSecondary">
                              Você pode selecionar mais de uma opção
                            </Typography>
                          </MaterialGrid>
                        </MaterialGrid>

                        {this.props.plans?.list?.content?.length > 0 && (
                          <>
                            <Typography
                              variant="subtitle2"
                              style={{ marginTop: 16, marginBottom: 8 }}>
                              Segmentar por Plano
                            </Typography>
                            <MaterialGrid container spacing={2}>
                              <MaterialGrid item xs={12} md={inlineAudience ? 12 : 6}>
                                <Field
                                  component={SelectMultiple}
                                  label="Escolha o plano"
                                  name="segment_plans"
                                  options={this.props.plans.list.content.map((p) => ({
                                    value: p.id,
                                    label: p.name,
                                  }))}
                                  multiple
                                  margin="normal"
                                />
                              </MaterialGrid>
                            </MaterialGrid>
                          </>
                        )}
                      </>
                    ) : null}
                  </MaterialGrid>

                  {inlineAudience ? (
                    <MaterialGrid item xs={12} md={6}>
                      <Typography variant="subtitle2" style={{ marginBottom: 8 }}>
                        Selecione os grupos da atividade
                      </Typography>
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          gap: 8,
                          marginTop: 8,
                        }}>
                        {AUDIENCE_OPTIONS.map((opt) => (
                          <Field
                            key={opt.value}
                            name={`audience_${opt.value}`}
                            component={audienceCheckbox(opt, false)}
                          />
                        ))}
                      </div>
                      {!hasAnyAudienceSelected(formValues) ? (
                        <FormHelperText style={{ color: '#FF5A52' }}>
                          Selecione pelo menos um público.
                        </FormHelperText>
                      ) : null}
                    </MaterialGrid>
                  ) : null}
                </MaterialGrid>
              );
            })()}

          {!(
            formValues?.has_target && formValues?.segmentation_type === 'public'
          ) ? (
            <AudienceSection
              auth={this.props.auth}
              isDisabled={false}
              formValues={formValues}
              marginTop={16}
            />
          ) : null}

          {/* Opções de Visibilidade */}
          <MaterialGrid item xs={12} style={{ marginTop: 16 }}>
            <Field
              component={InputSwitchLarge}
              label="Ocultar da área logada"
              name="only_public"
              margin="normal"
            />
          </MaterialGrid>
          <MaterialGrid item xs={12}>
            <Field
              component={InputSwitchLarge}
              label="Essa atividade estará em destaque para os participantes?"
              name="featuredPrivate"
              margin="normal"
            />
          </MaterialGrid>
          <MaterialGrid item xs={12}>
            <Field
              component={InputSwitchLarge}
              label="Essa atividade estará em destaque para os visitantes?"
              name="featuredPublic"
              margin="normal"
            />
          </MaterialGrid>
          <MaterialGrid item xs={12}>
            <Field
              component={InputSwitchLarge}
              label="Habilitar comentários e curtidas na atividade"
              name="comments_and_likes_enabled"
              margin="normal"
            />
          </MaterialGrid>

          {/* Alertas */}
          {productsCount === 0 && (
            <Alert severity="warning" style={{ marginBottom: 16 }}>
              Nenhum produto cadastrado. Adicione pelo menos um produto antes de publicar.
            </Alert>
          )}

          {stationsCount === 0 && (
            <Alert severity="info" style={{ marginBottom: 16 }}>
              Nenhuma station selecionada. A atividade será publicada apenas na station principal.
            </Alert>
          )}
        </div>

        {/* Botões */}
        <MaterialGrid
          container
          display="flex"
          justifyContent="space-around"
          alignItems="center"
          style={{ margin: '25px 0px', overflowX: 'hidden' }}>
          <SecondaryButton
            type="button"
            color="secondary"
            onClick={this.props.goBack}
            style={{ margin: 0, width: '48%', padding: '10px 20px', textTransform: 'none' }}>
            Voltar
          </SecondaryButton>
          <PrimaryButton
            type="button"
            color="primary"
            onClick={this.handleOpenConfirmCreate}
            disabled={isSubmitting || productsCount === 0}
            style={{ margin: 0, width: '48%', padding: '10px 20px', textTransform: 'none' }}>
            {isSubmitting ? 'Publicando...' : 'Ativar'}
          </PrimaryButton>
        </MaterialGrid>

        {/* Modal de Confirmação de Criação */}
        <Dialog
          open={this.state.showConfirmCreate}
          onClose={this.handleCloseConfirmCreate}
          maxWidth="xs"
          fullWidth
          disableEnforceFocus
          disableAutoFocus>
          <Box style={{ padding: 24, textAlign: 'center' }}>
            <IconButton
              onClick={this.handleCloseConfirmCreate}
              style={{ position: 'absolute', right: 8, top: 8 }}>
              <CloseIcon />
            </IconButton>
            <Typography variant="h6" style={{ marginBottom: 16 }}>
              Criação de nova atividade
            </Typography>
            <Typography variant="body2" color="textSecondary" style={{ marginBottom: 24 }}>
              Deseja criar uma nova atividade?
            </Typography>
            <Box style={{ display: 'flex', justifyContent: 'center', gap: 16 }}>
              <Button onClick={this.handleCloseConfirmCreate} color="primary">
                Cancelar
              </Button>
              <Button
                onClick={this.handleConfirmCreate}
                variant="contained"
                color="primary"
                disabled={isSubmitting}>
                {isSubmitting ? 'Criando...' : 'Confirmar'}
              </Button>
            </Box>
          </Box>
        </Dialog>
      </form>
    );
  }
}

Configuracoes.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  formValues: PropTypes.object,
  onClickProgress: PropTypes.func,
  goBack: PropTypes.func.isRequired,
  handleCancelClose: PropTypes.func,
  openConfirmation: PropTypes.bool,
  closeModal: PropTypes.func.isRequired,
  confirmationTitle: PropTypes.string,
  confirmationSubtitle: PropTypes.string,
  buttonConfirmationLabel: PropTypes.string,
  change: PropTypes.func.isRequired,
  publishToStations: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  plans: PropTypes.object,
  contacts: PropTypes.object,
  getContactsByStationIdLimited: PropTypes.func,
  getUsersByIds: PropTypes.func,
  getPlansList: PropTypes.func,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  formValues: getFormValues('vendasOnlineParceiroForm')(state),
  plans: state.plans,
  contacts: state.contacts,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      change: (field, value) => change('vendasOnlineParceiroForm', field, value),
      changeFieldAny: (formName, field, value) => change(formName, field, value),
      publishToStations,
      getContactsByStationIdLimited,
      getUsersByIds,
      getPlansList,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  reduxForm({
    form: 'vendasOnlineParceiroForm',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
  })(Configuracoes)
);
